import { getAxiosInstance } from "../../../api";

export const approveStockData = async (stockId, certificateNumbers = []) => {
  const api = await getAxiosInstance();
  let body = { id: stockId, certificate_numbers: certificateNumbers };
  try {
    const response = await api.post(
      `/verification/old-certificate/approve`,
      body
    );
    return response;
  } catch (error) {
    return error.response.data;
  }
};

export const rejectStockData = async (stockId) => {
  const api = await getAxiosInstance();
  let body = { id: stockId };
  try {
    const response = await api.post(
      `/verification/old-certificate/reject`,
      body
    );
    return response;
  } catch (error) {
    return error.response.data;
  }
};

export const uploadOldCertificateExcel = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(
      `/verification/old-certificate/excel-upload`,
      body
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const downloadOldCertificateExcel = async (
  receiptId,
  key = "excel_file"
) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(
      `/verification/old-certificate/excel-download`,
      { receipt_id: receiptId, key },
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
